import {FlightMode} from "../FlightMode";
import {GameMode} from "@nolimitcity/slot-game/bin/flowcontrol/GameMode";

export class RestoreUtils {

    public static isActionSpins = false;

    public static startupGame() {
        if (FlightMode.model.isRestore){
            RestoreUtils.restore();
        }
    }

    public static restore() {
        if (FlightMode.model.isFreespins() && !FlightMode.model.isExtraSpinPrompt())
            FlightMode.keypadPlugin.setZeroBetSpinCounter(FlightMode.model.freespinsLeft);
        FlightMode.backgroundElements.restore(!FlightMode.model.isFreespins() || FlightMode.model.isExtraSpinPrompt());
        FlightMode.updateKeypadWin();

        const multiplier = FlightMode.model.multiplier
        if (FlightMode.model.usedAFreespin() ||
            FlightMode.model.isExtraSpinPrompt() ||
            FlightMode.model.playedExtraSpin())
            FlightMode.reelView.updateMultiplierCounter(multiplier - 1).progress(1);
        else
            FlightMode.reelView.updateMultiplierCounter(multiplier).progress(1);

        FlightMode.reelView.getMaxWinSymbols().forEach((symbol, index) => {
            if (FlightMode.model.symbolSizes[index][3] == 1)
                symbol.unlockMaxWin().progress(1);
        })
    }

    public static playBonusInGame() {
        RestoreUtils.isActionSpins = true;

        FlightMode.backgroundElements.restore(true);
        FlightMode.updateKeypadWin();

        FlightMode.reelView.setSymbols(FlightMode.model.reels, FlightMode.model.symbolSizes);
        FlightMode.reelView.resetMultiplierCounter();
        if (FlightMode.model.multiplier > 1)
            FlightMode.reelView.resetMultiplierCounterTo(FlightMode.model.multiplier);

        FlightMode.reelView.getMaxWinSymbols().forEach((symbol, index) => {
            if (FlightMode.model.symbolSizes[index][3] == 1)
                symbol.unlockMaxWin().progress(1);
        })
    }
}